namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_file_attach, {
		
		Name: {
			padding: $mol_gap.text,
		},
		
	} )
	
}
